import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import {
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Panel,
  Flex,
  FlexItem,
  Grid,
  GridCell,
  GRID_VARIANT_VERTICAL_BIG,
  Text,
  Title,
  TITLE_VARIANT_XL,
  SkeletonLoader
} from 'mailup-web-components'
import moment from 'moment-timezone'

import IconEstimatedTime from './IconEstimatedTime'
import IconTotalRecipients from './IconTotalRecipients'
import {
  progressState,
  SENDING_METHOD_TYPE_FREQUENCY
} from 'Pages/EmailSendingWizard/recoil/state/queue'
import { notifyParent } from 'Helpers/notifyParent'

const BoxTotalRecipients = () => {
  const intl = useIntl()
  const [fTime, setFtime] = useState('')
  const { toBeQueued, sendMethodType, estimatedSendingTime } = useRecoilValue(
    progressState
  )

  const formatTime = () => {
    const secondsTime = moment.duration(estimatedSendingTime, 'seconds')
    const d = secondsTime.days()
    const h = secondsTime.hours()
    const m = secondsTime.minutes()
    const s = secondsTime.seconds()

    return `${intl.formatNumber(d)}d ${String(h).padStart(2, '0')}h ${String(
      m
    ).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`
  }

  useEffect(() => {
    setFtime(formatTime())
  }, [estimatedSendingTime])

  const handleUpsellClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshopem'
    ])
  }

  return (
    <>
      <Panel>
        <Grid cols={12} variantVertical={GRID_VARIANT_VERTICAL_BIG}>
          <GridCell span={6}>
            <Flex padding='16px 0'>
              <FlexItem padding='0 16px 0 0'>
                <IconEstimatedTime />
              </FlexItem>
              <Flex flexDirection='column'>
                {estimatedSendingTime === undefined ? (
                  <SkeletonLoader width='250px' height='32px' />
                ) : (
                  <Title variant={TITLE_VARIANT_XL}>{fTime}</Title>
                )}
                <Text>
                  {intl.formatMessage({ id: 'Load.Queue.EstimatedTime' })}
                </Text>
                <Link
                  variant={LINK_VARIANT_HIGHLIGHT}
                  onClick={handleUpsellClick}
                >
                  {sendMethodType === SENDING_METHOD_TYPE_FREQUENCY
                    ? intl.formatMessage({
                        id: 'Load.Queue.TempoStimatoUpsellingFrequenzaIntl'
                      })
                    : intl.formatMessage({
                        id: 'Load.Queue.TempoStimatoUpsellingBandaIntl'
                      })}
                </Link>
              </Flex>
            </Flex>
          </GridCell>
          <GridCell span={6}>
            <Flex padding='16px 0'>
              <FlexItem padding='0 16px 0 0'>
                <IconTotalRecipients />
              </FlexItem>
              <Flex flexDirection='column'>
                {!toBeQueued && <SkeletonLoader width='250px' height='32px' />}
                {toBeQueued && (
                  <Title variant={TITLE_VARIANT_XL}>
                    {intl.formatNumber(toBeQueued)}
                  </Title>
                )}
                <Text>
                  {intl.formatMessage({
                    id: 'Load.QueueStatus.RecipientsTotal'
                  })}
                </Text>
              </Flex>
            </Flex>
          </GridCell>
        </Grid>
      </Panel>
    </>
  )
}

export default BoxTotalRecipients
